import moment from "moment";

type StartOrEndTime = "startTime" | "endTime";

const getMomentFromDate = (d: Date) => moment.utc(`${d.getUTCHours()}:${d.getUTCMinutes()}`, "h:m");

const getMoment = (row: server.dto.TimetableEntry, startOrEnd: "startTime" | "endTime") => {
  const time = getMomentFromDate(new Date(row[startOrEnd]));
  if (row.nextDay) {
    time.add(1, "day");
  }

  return time;
};

const sortTimes = (a: server.dto.TimetableEntry, b: server.dto.TimetableEntry, startOrEnd: StartOrEndTime) => {
  if (a[startOrEnd] == null && b[startOrEnd] == null) {
    return 0;
  }
  if (a[startOrEnd] == null) {
    return -1;
  }
  if (b[startOrEnd] == null) {
    return 1;
  }

  const aMoment = getMoment(a, startOrEnd);
  const bMoment = getMoment(b, startOrEnd);

  return aMoment.valueOf() - bMoment.valueOf();
};

export const sortRows = (a: server.dto.TimetableEntry, b: server.dto.TimetableEntry) => {
  const difference = sortTimes(a, b, "startTime");
  if (difference !== 0) {
    return difference;
  }

  // If start times are equal, check end dates
  return sortTimes(a, b, "endTime");
};
